(function(){
  const MAX = 5;
  const root = document.querySelector('.nb-wrap');
  if (!root) return;

  if (!window.LLNecklace) {
    console.error('[necklace-builder] manca necklace-geometry.js: caricalo prima di questo file.');
    return;
  }

  const basePrice = parseInt(root.dataset.basePrice, 10);
  const variantNormal = parseInt(root.dataset.charmVariantNormal, 10);
  const variantEngraved = parseInt(root.dataset.charmVariantEngraved, 10);
  const productHandle = root.dataset.productHandle || '';
  const previewPath = root.dataset.previewPath || '/pages/preview-collana';

  // Geometria della catena: preset + eventuali override dal metafield
  const CHAIN = window.LLNecklace.resolve(root.dataset.chainPreset, root.dataset.chainTuning);

  const stage = root.querySelector('.nb-stage');
  const layer = document.getElementById('nbLayer');
  const priceEl = document.getElementById('nbPrice');
  const stickyPriceEl = document.getElementById('nbStickyPrice');
  const counterEl = document.getElementById('nbCounter');
  const dotsEls = document.querySelectorAll('.nb-dot');
  const summaryEl = document.getElementById('nbSummary');
  const summaryList = document.getElementById('nbSummaryList');
  const submitBtn = document.getElementById('nbSubmit');
  const stickySubmitBtn = document.getElementById('nbStickySubmit');
  const errorEl = document.getElementById('nbError');
  const allCharms = document.querySelectorAll('.nb-charm');

  // tabs
  const tabs = document.querySelectorAll('.nb-tab');
  const panes = document.querySelectorAll('.nb-charms-pane');

  // modale
  const modal = document.getElementById('nbModal');
  const modalInput = document.getElementById('nbModalInput');
  const modalCount = document.getElementById('nbModalCount');
  const modalMax = document.getElementById('nbModalMax');
  const modalMax2 = document.getElementById('nbModalMax2');
  const modalConfirm = document.getElementById('nbModalConfirm');

  // toast
  const toast = document.getElementById('nbToast');
  let toastTimer = null;

  let pendingCharm = null;
  if (modal) modal.hidden = true;

  let selected = [];
  let counter = 0;

  // Ricalcola posizioni dei charm al resize / cambio orientamento
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => render(), 200);
  });
  window.addEventListener('orientationchange', () => {
    setTimeout(() => render(), 300);
  });

  function formatMoney(cents){
    return '€' + (cents/100).toFixed(2).replace('.', ',');
  }

  function showToast(message){
    if (!toast) return;
    toast.textContent = message;
    toast.hidden = false;
    requestAnimationFrame(() => toast.classList.add('is-visible'));
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(() => {
      toast.classList.remove('is-visible');
      setTimeout(() => { toast.hidden = true; }, 250);
    }, 1800);
  }

  function render(){
    // 1. overlay sulla catena
    window.LLNecklace.paint(layer, selected, CHAIN, window.innerWidth < 990);

    // 2. stato bottoni
    allCharms.forEach(btn => {
      const id = btn.dataset.charmId;
      const isSel = selected.some(c => c.id === id);
      btn.classList.toggle('is-active', isSel);
      btn.classList.toggle('is-disabled', !isSel && selected.length >= MAX);

      btn.querySelectorAll('.nb-charm__engraving').forEach(e => e.remove());
      if (isSel) {
        const sel = selected.find(c => c.id === id);
        if (sel.engraving) {
          const span = document.createElement('span');
          span.className = 'nb-charm__engraving';
          span.textContent = '"' + sel.engraving + '"';
          btn.appendChild(span);
        }
      }
    });

    // 3. prezzo
    const extra = selected.reduce((s, c) => s + c.price, 0);
    const totalFormatted = formatMoney(basePrice + extra);
    if (priceEl) priceEl.textContent = totalFormatted;
    if (stickyPriceEl) stickyPriceEl.textContent = totalFormatted;

    // 4. counter + pallini (presenti solo in alcune versioni del template)
    if (counterEl) counterEl.textContent = `${selected.length} / ${MAX} ciondoli selezionati`;
    if (dotsEls && dotsEls.length) {
      dotsEls.forEach((dot, idx) => {
        dot.classList.toggle('is-filled', idx < selected.length);
      });
    }

    // 5. riassunto
    if (summaryEl && summaryList) {
      if (selected.length === 0) {
        summaryEl.hidden = true;
      } else {
        summaryEl.hidden = false;
        summaryList.innerHTML = selected.map(c => {
          const label = c.engraving
            ? `${c.name} – inciso "${c.engraving}"`
            : c.name;
          return `<li><span>${label}</span><span class="nb-summary__price">+${formatMoney(c.price)}</span></li>`;
        }).join('');
      }
    }

    if (errorEl) errorEl.hidden = true;
  }

  // ====== TABS ======
  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const target = tab.dataset.tab;
      tabs.forEach(t => t.classList.toggle('is-active', t === tab));
      panes.forEach(p => p.classList.toggle('is-active', p.dataset.pane === target));
    });
  });

  // ====== STAGE SCROLLED STATE (zoom leggero quando scrolli) ======
  if ('IntersectionObserver' in window) {
    const sentinel = document.createElement('div');
    sentinel.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:1px;';
    root.insertBefore(sentinel, root.firstChild);
    const io = new IntersectionObserver((entries) => {
      const e = entries[0];
      if (!e.isIntersecting) {
        stage.classList.add('is-scrolled');
      } else {
        stage.classList.remove('is-scrolled');
      }
    }, { threshold: 0 });
    io.observe(sentinel);
  }

  // ====== click su charm ======
  allCharms.forEach(btn => {
    btn.addEventListener('click', () => {
      const id = btn.dataset.charmId;
      const idx = selected.findIndex(c => c.id === id);

      if (idx >= 0) {
        const removed = selected[idx];
        selected.splice(idx, 1);
        render();
        showToast(`${removed.name} rimosso`);
        return;
      }

      if (selected.length >= MAX) {
        showToast('Hai raggiunto il massimo di 5 ciondoli');
        return;
      }

      const type = btn.dataset.charmType;
      const baseObj = {
        uniqueId: ++counter,
        id,
        name: btn.dataset.charmName,
        overlay: btn.dataset.charmOverlay,
        type,
        price: parseInt(btn.dataset.charmPrice, 10)
      };

      if (type === 'engraved') {
        pendingCharm = baseObj;
        const maxC = parseInt(btn.dataset.maxChars, 10) || 10;
        modalInput.maxLength = maxC;
        modalMax.textContent = maxC;
        modalMax2.textContent = maxC;
        modalInput.value = '';
        modalCount.textContent = '0';
        modal.hidden = false;
        setTimeout(() => modalInput.focus(), 10);
      } else {
        selected.push(baseObj);
        render();
        showToast(`${baseObj.name} aggiunto`);
      }
    });
  });

  // ====== modale ======
  modalInput.addEventListener('input', () => {
    modalCount.textContent = modalInput.value.length;
  });
  modal.querySelectorAll('[data-close]').forEach(el => {
    el.addEventListener('click', () => {
      modal.hidden = true;
      pendingCharm = null;
    });
  });
  modalConfirm.addEventListener('click', () => {
    const text = modalInput.value.trim();
    if (!text || !pendingCharm) return;
    pendingCharm.engraving = text;
    selected.push(pendingCharm);
    const name = pendingCharm.name;
    pendingCharm = null;
    modal.hidden = true;
    render();
    showToast(`${name} aggiunto`);
  });
  modalInput.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') { e.preventDefault(); modalConfirm.click(); }
    if (e.key === 'Escape') { modal.hidden = true; pendingCharm = null; }
  });

  // ====== LINK ANTEPRIMA ======
  // Formato: /pages/preview-collana?p=handle&c=charm-7,charm-13~MARIA
  function buildPreviewUrl(){
    const c = selected.map(x => {
      return x.engraving ? x.id + '~' + encodeURIComponent(x.engraving) : x.id;
    }).join(',');
    return window.location.origin + previewPath +
           '?p=' + encodeURIComponent(productHandle) +
           '&c=' + c;
  }

  // ====== ADD TO CART (sia bottone inline che sticky) ======
  async function addToCart(){
    const buttons = [submitBtn, stickySubmitBtn].filter(Boolean);
    buttons.forEach(b => { b.classList.add('is-loading'); b.disabled = true; });
    if (errorEl) errorEl.hidden = true;

    try {
      const linkKey = 'NCK-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8);

      const charmListStr = selected.length
        ? selected.map(c => {
            const priceLabel = `+${formatMoney(c.price)}`;
            return c.engraving
              ? `${c.name} (inciso: "${c.engraving}") ${priceLabel}`
              : `${c.name} ${priceLabel}`;
          }).join(', ')
        : '';

      const items = [];
      const variantSelector = document.querySelector('[name="id"]');
      const necklaceItem = {
        id: variantSelector ? parseInt(variantSelector.value, 10) : null,
        quantity: 1,
        properties: { '_ll_bundle_key': linkKey }
      };
      if (charmListStr) necklaceItem.properties['Ciondoli'] = charmListStr;

      if (selected.length) {
        // dati per l'anteprima nel carrello
        necklaceItem.properties['_ll_charms'] = JSON.stringify(
          selected.map(c => ({
            id: c.id,
            name: c.name,
            overlay: c.overlay,
            engraving: c.engraving || ''
          }))
        );
        necklaceItem.properties['_ll_chain'] = JSON.stringify(CHAIN);
        // link visibile nell'ordine che ricevi in admin
        necklaceItem.properties['_Anteprima collana'] = buildPreviewUrl();
      }

      items.push(necklaceItem);

      selected.forEach(c => {
        const item = {
          id: c.type === 'engraved' ? variantEngraved : variantNormal,
          quantity: 1,
          properties: { '_ll_linked_to': linkKey, 'Tipo': c.name }
        };
        if (c.engraving) item.properties['Incisione'] = c.engraving;
        items.push(item);
      });

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items })
      });

      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.description || 'Errore durante l\'aggiunta al carrello');
      }

      const cartDrawer = document.querySelector('cart-drawer, cart-notification');
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        cartDrawer.open();
      } else {
        window.location.href = '/cart';
      }

    } catch(e) {
      if (errorEl) {
        errorEl.textContent = e.message || 'Errore. Riprova.';
        errorEl.hidden = false;
      }
      showToast('Errore: ' + (e.message || 'riprova'));
    } finally {
      buttons.forEach(b => { b.classList.remove('is-loading'); b.disabled = false; });
    }
  }

  if (submitBtn) submitBtn.addEventListener('click', addToCart);
  if (stickySubmitBtn) stickySubmitBtn.addEventListener('click', addToCart);

  render();
})();